module.exports = __webpack_public_path__ + "static/media/gallery-6.de9d31ed.jpg";